import { render, staticRenderFns } from "./ContactIndex.vue?vue&type=template&id=3c5f600e"
import script from "./ContactIndex.vue?vue&type=script&lang=js"
export * from "./ContactIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports